const API_BASE = 'https://new.sbdemolition.online/api/residence';

export const residenceAPI = {
  // جيب كل الموظفين
  list: async () => {
    const res = await fetch(`${API_BASE}/list.php`, {
      credentials: 'include',
    });
    return res.json();
  },

  // حدّث visa أو passport expiry
  update: async (userId, visaExpiry, passportExpiry) => {
    const res = await fetch(`${API_BASE}/update.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        userId,
        visaExpiry,
        passportExpiry,
      }),
    });
    return res.json();
  },
};
